<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <nav1 v-if="!blnClinicaDescentralizada"></nav1>
    <nav2 v-else></nav2>
  </div>
</template>

<script>

import Nav1 from "@/components/navbar/navbarV1/nav1";
import Nav2 from "@/components/navbar/navbarV2/nav2";

export default {
  components: {Nav2, Nav1},
  nombreMenu: "Header",
  props: {
    msg: String,
  },
  data (){
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      blnClinicaDescentralizada: false,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.obtenerClinicaTieneDesentralizado();
  },
  methods:{
    obtenerClinicaTieneDesentralizado() {
      this.loadingPaciente = true;
      const parametros = {
        idClinica: this.$localStorageService.getIdClinica(),
        idConfiguracion: 4
      }
      this.$http
          .post(
              this.$api +
              "configuracionClinica/obteneValidacionConfiguracionClinica ", parametros
          )
          .then((response) => {
            this.blnClinicaDescentralizada = response.data.data;
          })
    }
  }
};
</script>
<style scoped>
</style>
